// React hooks
import { useEffect, useState } from 'react';

const useTheme = () => {
  // State for current theme
  const [theme, setTheme] = useState(() =>
    localStorage.getItem('theme') || 'light'
  );

  // Apply theme to document root
  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Toggle theme
  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  // Return API
  return { theme, toggleTheme };
};

export default useTheme;